import req from "@/request.js";
const form = req.getContext().form;
const third = req.getContext().third;
const portal = req.getContext().portal;
const business = req.getContext().business;
export default {
  getByAliasCq(alias, cb) {
    req.post(form + `/form/customQuery/v1/getByAlias`, alias).then(response => {
      cb(response.data);
    });
  },
  selectQuery(customQuery, cb) {
    var queryUrl =
      customQuery.dsType == "dataSource"
        ? "${form}/form/customQuery/v1/doQueryBase64?alias=" + customQuery.alias
        : customQuery.url;
    var requestType = customQuery.requestType ? customQuery.requestType : "GET";
    var queryData = customQuery.queryData ? customQuery.queryData : "";
    queryData = Base64.encode(queryData);
    var currentPage = customQuery.currentPage ? customQuery.currentPage : 1;
    if (customQuery.dsType == "dataSource") {
      req
        .get(queryUrl + `&queryData=` + queryData + `&page=` + currentPage)
        .then(response => {
          cb(response.data);
        });
    }
    if (requestType == "POST" && customQuery.dsType == "restful") {
      req.post(queryUrl, customQuery.pageBean).then(response => {
        cb(response.data);
      });
    }
    if (requestType == "GET" && customQuery.dsType == "restful") {
      req.get(queryUrl, customQuery.pageBean).then(response => {
        cb(response.data.row ? response.data : { rows: response.data });
      });
    }
  },
  saveTemplateData(data) {
    return new Promise((resolve, reject) => {
      req.post(form + `/form/dataTemplate/v1/save`, data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //获取数据视图变量
  getDataTemplateVarList(id) {
    return new Promise((resolve, reject) => {
      req.get(form + `/form/dataTemplate/v1/getVarList`).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getPageJson(param) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/form/v1/list", param).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //数据建模分类树数据
  getBusinessObjTree(param, cb) {
    req
      .get(portal + `/sys/sysType/v1/getTypesByKey?typeKey=${param}`)
      .then(response => {
        cb(response);
      });
  },
  //获取数据建模数据
  getBusinessObjData(param) {
    return new Promise((resovle, rejct) => {
      req.post(form + "/bo/def/v1/list", param).then(
        resp => {
          resovle(resp.data);
        },
        error => {
          rejct(error);
        }
      );
    });
  },
  //获取数据视图
  getDataformation(param, cb) {
    req.get(form + `/bo/def/v1/getBoJson?alias=${param}`).then(resp => {
      cb(resp);
    });
  },
  //修改数据建模状态
  updateBusinessObjStatus(id, status) {
    return new Promise((resolve, rejct) => {
      req.get(form + `/bo/def/v1/setStatus?id=${id}&status=${status}`).then(
        resp => {
          resolve(resp);
        },
        error => {
          rejct(error);
        }
      );
    });
  },
  //删除建模数据
  removeBusinessObj(id) {
    return new Promise((resolve, rejct) => {
      req.remove(form + `/bo/def/v1/removes?ids=${id}`).then(
        resp => {
          resolve(resp);
        },
        error => {
          rejct(error);
        }
      );
    });
  },
  //获取分类
  getCategory(type, cb) {
    req
      .get(portal + `/sys/sysType/v1/getByGroupKey?groupKey=${type}`)
      .then(resp => {
        cb(resp);
      });
  },
  //修改分类
  updateCategory(ids, categoryId, categoryName) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form +
            `/bo/def/v1/updateCategory?ids=${ids}&categoryId=${categoryId}&categoryName=${categoryName}`
        )
        .then(
          resp => {
            resolve(resp);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  //获取表单
  getEntData(id, cb) {
    req.get(form + `/bo/def/v1/getJson?id=${id}`).then(resp => {
      cb(resp);
    });
  },
  //保存实体
  saveEntData(json) {
    return new Promise((resolve, reject) => {
      req.post(form + `/bo/def/v1/createTableForm`, json).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //逻辑删除字段
  removeAttr(attr) {
    return new Promise((resolve, reject) => {
      req.post(form + `/bo/def/v1/removeAttr`, attr).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //还原删除字段
  recovery(attr) {
    return new Promise((resolve, reject) => {
      req.post(form + `/bo/def/v1/recovery`, attr).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //发布
  deploy(id) {
    return new Promise((resolve, reject) => {
      req.get(form + `/bo/def/v1/deploy?id=${id}`).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //数据源
  getDataSource() {
    return new Promise((resolve, reject) => {
      req.get(portal + `/sys/sysDataSource/v1/getDataSources`).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //选中外部表
  getTableList(param) {
    return new Promise((resolve, reject) => {
      req.post(form + `/form/customQuery/v1/getByDsObjectName`, param).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //外部表切换
  changeTableName(param) {
    return new Promise((resolve, reject) => {
      req.post(form + `/form/customQuery/v1/getTable`, param).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //模板管理数据
  templateListData(param) {
    return new Promise((resolve, reject) => {
      req.post(form + `/form/template/v1/list`, param).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //设置默认模板
  setDefault(id, type) {
    return new Promise((resolve, reject) => {
      req.get(form + `/form/template/v1/setDefault?id=${id}&type=${type}`).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //模板复制
  copyTemplate(id, name, alias) {
    return new Promise((resolve, reject) => {
      req
        .post(
          form +
            `/form/template/v1/copyTemplate?templateId=${id}&newTemplateName=${name}&newAlias=${alias}`
        )
        .then(
          resp => {
            resolve(resp);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  //初始化模板
  initTemplate() {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/template/v1/init").then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //根据别名判断表单模板是否已经存在  返回结果：true：不存在，false：存在
  isTemplateByAlias(alias) {
    return new Promise((resolve, reject) => {
      req
        .get(form + "/form/template/v1/isTemplateByAlias?alias=" + alias)
        .then(resp => {
          resolve(resp);
        });
    });
  },
  //获取绑定数据
  getBindData(id, alias) {
    return new Promise((resolve, reject) => {
      req.get(form + `/bo/def/v1/getBindData?id=${id}&alias=${alias}`).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //获取业务数据模板列表数据
  getDataTemplateData(param) {
    return new Promise((resolve, reject) => {
      req.post(form + `/form/dataTemplate/v1/listToJson`, param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //获取表单列表数据
  getFormData(param) {
    return new Promise((resolve, reject) => {
      req
        .post(form + `/form/form/v1/list?formType=pc&status=deploy`, param)
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  //根据表单别名获取数据视图数据
  getBpmDataTemplate(formKey, boId) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form +
            `/form/dataTemplate/v1/getBpmDataTemplate?formKey=${formKey}&boId=${boId}`
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  getBpmDataTemplateById(id, boId) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form + `/form/dataTemplate/v1/getByTemplateId?id=${id}&boId=${boId}`
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  getBpmDataTemplateInfo(alias) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form + `/form/dataTemplate/v1/getBpmDataTemplateInfo?alias=` + alias
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  getTemplateDataListForm(alias) {
    return new Promise((resolve, reject) => {
      req.post(form + `/form/dataTemplate/v1/dataList_` + alias, {}).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  saveTemplateHtml(param) {
    return new Promise((resolve, reject) => {
      req
        .post(
          form + `/form/dataTemplate/v1/saveTemplate?id=` + param.id,
          param.templateHtml
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  //获取业务数据列表
  getBpmTemplateByPagination(data) {
    return new Promise((resolve, reject) => {
      req
        .post(
          form + `/form/dataTemplate/v1/listJson/` + data.templateId,
          data.pagination
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  getCustomDialogs() {
    return new Promise((resolve, reject) => {
      req.post(form + `/form/customDialog/v1/getAll`, {}).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getCustomDialogByAlias(alias) {
    return new Promise((resolve, reject) => {
      req.get(form + `/form/customDialog/v1/getByAlias?alias=` + alias).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getCustomChartList(param) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/customChart/v1/list", param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getCustomChartById(id) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/customChart/v1/get/" + id).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  saveCustomChart(param) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/customChart/v1/save", param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  checkSql(param) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/query/querySqldef/checkSql", param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getQuerySqlDef(alias) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/query/querySqldef/getJson?alias=" + alias).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getTable(param) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/customChart/v1/getTable", param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getListData(alias, params) {
    return new Promise((resolve, reject) => {
      req
        .post(form + "/form/customChart/v1/getListData?alias=" + alias, params)
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  getCustomViewList(param) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/query/querySqldef/listJson", param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getCustomViewById(id) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/query/querySqldef/getJson?id=" + id).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getViewList(param, alias) {
    return new Promise((resolve, reject) => {
      req
        .post(form + "/form/query/queryView/listJson?sqlAlias=" + alias, param)
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  getViewById(id) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/query/queryView/getJson?id=" + id).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getTemplateList() {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/query/queryView/getTempList", {}).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  refreshFields(id) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/query/querySqldef/refreshFields?id=" + id).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  saveCustomView(param) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/query/querySqldef/save", param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getCustomDialog() {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/customDialog/v1/getAll", {}).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getQueryViewTemplate(id) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/query/queryView/getJson?id=" + id).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  saveQueryViewTemplate(id, param) {
    return new Promise((resolve, reject) => {
      req
        .post(form + "/form/query/queryView/saveTemplate?id=" + id, param)
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  saveView(param) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/query/queryView/save", param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getComVarList(param) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/dataTemplate/v1/getVarList").then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }, //保存引入脚本和样式对象
  saveFormJs(param) {
    return new Promise((resolve, reject) => {
      req.post(form + `/form/form/v1/saveFormJs`, param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  importCustomSql(param) {
    return new Promise((resolve, reject) => {
      req.post(form + `/form/query/querySqldef/import`, param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //物理删除字段
  deleteAttr(id) {
    return new Promise((resolve, reject) => {
      req.post(form + `/bo/def/v1/deleteAttr?id=${id}`).then(
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getCustomDialogList(param) {
    return new Promise((resolve, reject) => {
      req.post(window.context.form + "/form/customDialog/v1/list", param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getBindRelation(defId, formKey) {
    return new Promise((resolve, reject) => {
      req
        .get(
          window.context.form +
            `/form/form/v1/getBindRelation?defId=${defId}&formKey=${formKey}`
        )
        .then(
          resp => {
            resolve(resp);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  getBODefByFormId(formId) {
    return new Promise((resolve, reject) => {
      req
        .get(
          window.context.form +
            `/form/dataTemplate/v1/getBODefByFormId?formId=${formId}`
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  getHideAttr(tableName) {
    return new Promise((resolve, reject) => {
      req
        .get(
          window.context.form + `/bo/def/v1/getHideAttr?tableName=${tableName}`
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  getViewManageList(param) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/viewManage/v1/listJson", param).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  createPhysicalViewByViewMngId(id) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/viewManage/v1/createPhysicalView/" + id).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  savePrintTemplate(data) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/form/v1/savePrintTemplate", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 合同模板
  getContractTemplateList(data) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/form_contract_template/v1/list", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 易筑模板库
  getIezuContractTemplateList(data) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/form_contract_template/v1/defaultList", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 删除合同模板
  getContractTemplateDel(data) {
    return new Promise((resolve, reject) => {
      req
        .remove(form + "/form/form_contract_template/v1/" + data.id, data)
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 启动、停用合同模板
  getContractTemplatePublish(data) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/form_contract_template/v1/publish", "", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 批量删除合同模板记录
  getContractTemplateRemove(data) {
    return new Promise((resolve, reject) => {
      req
        .remove(
          form + "/form/form_contract_template/v1/remove?ids=" + data.id,
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 查看合同模板的所有版本
  getContractTemplateVersions(data) {
    return new Promise((resolve, reject) => {
      req
        .post(form + "/form/form_contract_template/v1/listVersions", data)
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 检查别名是否存在
  getContractTemplateCheckKey(data) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/form_contract_template/v1/checkKey", "", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 设置默认版本
  getContractTemplateSetDefaultVersion(data) {
    return new Promise((resolve, reject) => {
      req
        .post(form + "/form/form_contract_template/v1/setDefaultVersion", data)
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  //  添加实体的接口
  getContractTemplateAdd(data) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/form_contract_template/v1/", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //  更新实体
  getContractTemplateUpdate(data) {
    return new Promise((resolve, reject) => {
      req.put(form + "/form/form_contract_template/v1/", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //  根据上传的模板文件id解析成detail对象
  getDetailListByFileId(data) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form + "/form/form_contract_template/v1/getDetailListByFileId",
          "",
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  //  api/form/bo/def/v1/list
  getBoDefList(data) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/def/v1/list", "", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //   保存合同模板
  getContractTemplateSave(data) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/form_contract_template/v1/save", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //   获取合同模板常量下拉
  getDetailListByEnumMap(data = {}) {
    return new Promise((resolve, reject) => {
      req
        .get(form + "/form/form_contract_template/v1/getEnumMap", "", data)
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  //   根据合同模板id创建新的合同模板版本
  getDetailListByNewVersion(data = {}) {
    return new Promise((resolve, reject) => {
      req.post(form + "/form/form_contract_template/v1/newVersion", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //   根据ID获取合同模板明细
  getDetailListById(data = {}) {
    return new Promise((resolve, reject) => {
      req.get(form + "/form/form_contract_template/v1/getById", "", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //   根据ID获取易筑模板库合同模板明细
  getIezuDetailListById(data = {}) {
    return new Promise((resolve, reject) => {
      req
        .get(form + "/form/form_contract_template/v1/getDefaultById", "", data)
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 获取指定bodef的所有实体信息
  getChildListByDefId(data = {}) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form + "/form/formServiceController/v1/getChildListByDefId",
          "",
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 获取指定boDef主表的属性信息
  getAttrListByDefId(data = {}) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form + "/form/formServiceController/v1/getAttrListByDefId",
          "",
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 获取指定boDef所有属性信息
  getAllAttrListByDefId(data = {}) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form + "/form/formServiceController/v1/getAllAttrListByDefId",
          "",
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 获取合同模板转换常量下拉
  getDetailListByEnumConvertMap(data = {}) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form + "/form/form_contract_template/v1/getEnumConvertMap",
          "",
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 根据模型定义id获取表单
  getListByBoDefId(data = {}) {
    return new Promise((resolve, reject) => {
      req
        .get(
          form + "/form/form_contract_template/v1/getListByBoDefId",
          "",
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 计费中心
  // 套餐列表
  getPackageCenterList(data) {
    return new Promise((resolve, reject) => {
      req.post(third + "/account/third_combo/query", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 根据收费类型查找关联产品
  getRelateProductByChargeType(data) {
    return new Promise((resolve, reject) => {
      req
        .get(
          third +
            "/account/third_combo/getAccountModuleByType/" +
            data.chargeType,
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 获取数据字典tree
  getByTypeKeyForComBo(data) {
    return new Promise((resolve, reject) => {
      req
        .post(
          portal +
            "/sys/dataDict/v1/getByTypeKeyForComBo?typeKey=" +
            data.typeKey,
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 添加套餐的接口
  getDetailThirdCombo(data) {
    return new Promise((resolve, reject) => {
      req.get(third + "/account/third_combo/" + data.id, data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 根据id查询套餐
  getAddThirdCombo(data) {
    return new Promise((resolve, reject) => {
      req.post(third + "/account/third_combo/", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 根据id更新套餐
  getUpdateThirdCombo(data) {
    return new Promise((resolve, reject) => {
      req.put(third + "/account/third_combo/", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 根据id删除套餐
  getDelThirdCombo(data) {
    return new Promise((resolve, reject) => {
      req.remove(third + "/account/third_combo/" + data.id, data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 消费记录列表
  getbillRecordList(data, subData) {
    return new Promise((resolve, reject) => {
      req
        .post(
          third +
            "/system/account_mangement/getBillingRecordsList?tenantId=" +
            subData.tenantId,
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },

  // 用车规则维护列表
  getYcgzList(data) {
    return new Promise((resolve, reject) => {
      req
        .post(
          third +
            "/meiTuan/third_sqt_role/query",data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 关联用户列表
  getRelateUserList(data, subData) {
    return new Promise((resolve, reject) => {
      req
        .post(
          third +
            "/costcenter/account_user/getByAccountId/?accountId=" +
            subData.accountId,
          data
        )
        .then(
          resp => {
            resolve(resp.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 添加关联用户列表
  getAddRelateUser(data) {
    return new Promise((resolve, reject) => {
      req.post(third + "/costcenter/account_user/createBatch", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 解除关联用户
  getRemoveRelateUser(data) {
    return new Promise((resolve, reject) => {
      req.remove(third + "/costcenter/account_user/" + data.id, data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 表单扩展字段配置保存
  saveFormExpandConfig(data) {
    return new Promise((resolve, reject) => {
      req.post(form + "/expand/config/", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 表单扩展字段配置保存
  updateFormExpandConfig(data) {
    return new Promise((resolve, reject) => {
      req.put(form + "/expand/config/", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 表单扩展字段配置保存
  getFormExpandConfigByFormKey(data) {
    return new Promise((resolve, reject) => {
      req.get(form + "/expand/config_form_key/" + data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 申请报告模板
  getOaContractTemplateList(data) {
    return new Promise((resolve, reject) => {
      req.post(business + "/oa/oa_report_template/query", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 申请报告模板
  getOaContractTemplateById(data) {
    return new Promise((resolve, reject) => {
      req.get(business + "/oa/oa_report_template/" + data.id).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 保存申请报告模板
  saveOaContractTemplate(data) {
    return new Promise((resolve, reject) => {
      req.post(business + "/oa/oa_report_template/", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 保存申请报告模板
  updateOaContractTemplate(data) {
    return new Promise((resolve, reject) => {
      req.put(business + "/oa/oa_report_template/", data).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 保存申请报告模板
  delOaContractTemplate(data) {
    return new Promise((resolve, reject) => {
      req.remove(business + `/oa/oa_report_template/?ids=${data.ids}`).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // 文件上传
  fileUpload(params) {
    return new Promise((resolve, reject) => {
      req.post(portal + `/system/file/v1/upload`, params).then(
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};
